import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UrlFlagsService, UserStrategy } from 'shared';
import { EmbeddedLayoutComponent } from '../embedded-layout/embedded-layout.component';
import { MainLayoutComponent } from '../main-layout/main-layout.component';

@Component({
  selector: 'ocp-app-template',
  imports: [RouterOutlet, MainLayoutComponent, EmbeddedLayoutComponent],
  templateUrl: './app-template.component.html',
})
export class AppTemplateComponent {
  readonly isEmbedded = inject(UrlFlagsService).embedded;

  private readonly userFacade = inject(UserStrategy);

  readonly userInitials = computed(() => this.userFacade.user()?.initials ?? '');
  readonly userName = computed(() => {
    const user = this.userFacade.user();
    return [user?.firstName, user?.lastName].filter(Boolean).join(' ');
  });
  readonly userEmail = computed(() => this.userFacade.user()?.email ?? '');
}
